import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext, text: string, subject = '') {
  return this.sendEventWithCallback('share', { text, subject })
    .then((data: unknown) => {
      const d = data as { shared?: boolean }
      if (d.shared === true) {
        return
      }
      return Promise.reject(
        new Error(this.ERROR_UNKNOWN)
      )
    })
}
